const localeData = {
    en: 'scribbr.com',
    'en_GB': 'scribbr.co.uk',
    no: 'scribbr.no',
    da: 'scribbr.dk',
    nl: 'scribbr.nl',
    fi: 'scribbr.fi',
    fr: 'scribbr.fr',
    de: 'scribbr.de',
    it: 'scribbr.it',
    es: 'scribbr.es',
    sv: 'scribbr.se',
    'de_AT': 'scribbr.at',
    'de_CH': 'scribbr.ch',
};

const currencyForDomain = {
    'scribbr.com': 'USD',
    'scribbr.co.uk': 'GBP',
    'scribbr.no': 'NOK',
    'scribbr.dk': 'DKK',
    'scribbr.nl': 'EUR',
    'scribbr.fi': 'EUR',
    'scribbr.fr': 'EUR',
    'scribbr.de': 'EUR',
    'scribbr.it': 'EUR',
    'scribbr.es': 'EUR',
    'scribbr.se': 'SEK',
    'scribbr.at': 'EUR',
    'scribbr.ch': 'CHF',
};

function localeFromDomain() {
    let localeFromDomain = 'en';

    Object.values(localeData).some((domain, index) => {
        const tld = domain.substring(domain.indexOf('.'));
        if (window.location.host.endsWith(tld)) {
            localeFromDomain = Object.keys(localeData)[index];
        }
    });

    return localeFromDomain;
};

function fallbackLocale(returnSingleFallback = false) {
    let locale = localeFromDomain();

    let parentLocale = locale.split('_')[0];

    if (parentLocale === locale) {
        return 'en';
    }

    return returnSingleFallback ? parentLocale : [parentLocale, 'en'];
};

function currentDomain() {
    let currentDomain = 'scribbr.com';

    Object.values(localeData).some((domain) => {
        const tld = domain.substring(domain.indexOf('.'));
        if (window.location.host.endsWith(tld)) {
            currentDomain = domain;
        }
    });

    return currentDomain;
}

function tldFromDomain() {
    return window.location.host.split('.', 3)[2] || 'com';
}

function getCurrencyForDomain() {
    return currencyForDomain[currentDomain()] || 'USD';
};

export {
    localeData,
    localeFromDomain,
    currentDomain,
    fallbackLocale,
    tldFromDomain,
    getCurrencyForDomain,
};
